// src/services/api.js
import axios from 'axios';
import { slowlorisProtection } from './slowlorisProtection';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// Request interceptor — apply Slowloris protection
api.interceptors.request.use(
  (config) => {
    return slowlorisProtection.protectAxiosConfig(config);
  },
  (error) => Promise.reject(error)
);

api.interceptors.request.use((config) => {
  const sessionId = sessionStorage.getItem('ams_session_id');
  if (sessionId) {
    config.headers['x-session-id'] = sessionId;
  }
  return config;
});

// Response interceptor — track completion + handle session timeout
api.interceptors.response.use(
  (response) => {
    const { _slowlorisRequestId, _slowlorisClientId } = response.config;
    if (_slowlorisRequestId) {
      slowlorisProtection.completeRequest(_slowlorisRequestId, _slowlorisClientId, true);
    }
    return response;
  },
  (error) => {
    const config = error.config || {};
    const { _slowlorisRequestId, _slowlorisClientId } = config;
    if (_slowlorisRequestId) {
      slowlorisProtection.completeRequest(_slowlorisRequestId, _slowlorisClientId, false);
    }

    if (error.response?.status === 401) {
      const isAuthEndpoint = config.url?.includes('/auth/');
      if (!isAuthEndpoint) {
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        alert('Session expired. Please login again.');
        window.location.href = '/';
        return Promise.reject(new Error('Session expired'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
